<template>
  <BaseSearchBox v-bind="style"
                 v-model="input"
                 v-on="$listeners"
                 :clearButtonStyle="clearButtonStyle"
                 :disabled="disabled"
                 :filled="input.length > 0"
                 :iconContainerStyle="iconContainerStyle"
                 :iconStyle="iconStyle"
                 :inputStyle="inputStyle"
                 @clear="clear">
  </BaseSearchBox>
</template>

<script>
  import BaseSearchBox from '@base/base-search-box'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SearchBoxPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'input',
    },
    components: {
      BaseSearchBox,
    },
    props: {
      vmodelValue: { type: String },
      disabled: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        clearButtonStyle: {
          cursor: 'pointer',
          fontSize: '16px',
        },
        iconContainerStyle: {
          cursor: { '': 'pointer', disabled: 'default' },
          margin: `0 0 0 ${Layout.space.sm}`,
        },
        iconStyle: {
          fontSize: '16px',
        },
        input: '',
        inputStyle: {
          lineHeight: FontStyle.size.md,
          fontSize: FontStyle.size.md,
          paddingBottom: '2px',
        },
        style: {
          borderRadius: Layout.space.sm,
        },
      };
    },
    created: function () {
      this.input = this.vmodelValue;

      this.clearButtonStyle = {
        ...this.clearButtonStyle,
        color: this.color.dark3(),
      };

      this.iconStyle = {
        ...this.iconStyle,
        color: this.color.dark3(),
      };

      this.inputStyle = {
        ...this.inputStyle,
        color: {
          '': this.color.dark2(),
          placeholder: this.color.dark3(),
          disabled: this.color.dark4(),
        },
      };

      this.style = {
        ...this.style,
        backgroundColor: this.color.light1(),
        border: `solid ${this.color.dark5()}`,
        borderWidth: '1px',
        height: '32px',
        lineHeight: FontStyle.size.md,
        padding: `0 ${Layout.space.md}`,
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    methods: {
      clear: function () {
        this.input = '';
        this.$emit('input', this.input);
      },
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.input = this.vmodelValue;
      },
    },
  };
</script>
